export const TRIGGER_VAPI_BUTTON_CLICK = 'TRIGGER_VAPI_BUTTON_CLICK';